var Gsap = (function($) {
  function initGsap() {
    gsap.registerPlugin(ScrollTrigger);
  }

  function initLandingAnimation() {
    window.addEventListener("load", () => {
      const hero = document.querySelector(".landing-hero");
      const heading = document.querySelector(".landing-hero__heading");
      const image = document.querySelector(".landing-hero__image");

      const headerLogo = document.querySelector(".header-logo");
      const headerNav = document.querySelector(".header-nav");

      if (!hero || !heading || !image) return;

      const mm = gsap.matchMedia();

      // DESKTOP
      mm.add("(min-width: 768px)", () => {
        if (headerLogo) {
          gsap.set(headerLogo, {
            autoAlpha: 0
          });
        }

        if (headerNav) {
          gsap.set(headerNav, {
            autoAlpha: 0,
            y: -8
          });
        }

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: hero,
            start: "top top",
            end: "+=100%",
            scrub: true,
            pin: true,
            anticipatePin: 1,
            invalidateOnRefresh: true
          }
        });

        // Logo grande → posición header
        tl.to(
          heading,
          {
            fontSize: "28px",
            left: "36px",
            top: "24px",
            bottom: "auto",
            ease: "none",
            duration: 1
          },
          0
        );

        // Imagen → tamaño final
        tl.to(
          image,
          {
            scale: 0.55,
            duration: 1,
            ease: "none"
          },
          0
        );

        if (headerLogo) {
          // Negro justo al llegar arriba
          tl.set(
            heading,
            {
              color: "#111"
            },
            0.94
          );

          // Desaparece heading animado
          tl.to(
            heading,
            {
              autoAlpha: 0,
              duration: 0.05,
              ease: "none"
            },
            0.95
          );

          // Aparece logo real del header
          tl.to(
            headerLogo,
            {
              autoAlpha: 1,
              duration: 0.03,
              ease: "none"
            },
            0.97
          );
        }

        if (headerNav) {
          tl.to(
            headerNav,
            {
              autoAlpha: 1,
              y: 0,
              duration: 0.08,
              ease: "none"
            },
            0.98
          );
        }
      });

      // MOBILE
      mm.add("(max-width: 767px)", () => {
        // No mostramos el heading grande
        gsap.set(heading, {
          autoAlpha: 0
        });

        // Imagen directamente en posición final
        gsap.set(image, {
          scale: 0.55
        });

        // Header visible desde el principio
        if (headerLogo) {
          gsap.set(headerLogo, {
            autoAlpha: 1
          });
        }

        if (headerNav) {
          gsap.set(headerNav, {
            autoAlpha: 1,
            y: 0
          });
        }
      });
    });
  }

  function init() {
    if (!$(".page-template-template-landing").length) {
      return;
    }

    initGsap();
    initLandingAnimation();
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(Gsap.init);
